import React from "react";

import DIAGTokenFutureHealthcarePayments from "../../components/BlogDetails/DIAGTokenFutureHealthcarePayments";
import LayoutTwo from "../../layouts/LayoutTwo";

const BlogDetailsPage = () => {
  return (
    <LayoutTwo pageTitle={"Blog Details"} item={"BLOG DETAILS"}>
      <DIAGTokenFutureHealthcarePayments />
    </LayoutTwo>
  );
};

export default BlogDetailsPage;
